import {
  Issue,
  IssueDetails,
} from '@/stores/AccessibilityCheckerStore/AccessibilityChecker.consts';
import { IssueContent } from './IssueContent';

export type IssueContentProps = {
  issue: Issue;
};

export type IssueDetailsProps = {
  item: IssueDetails;
  index: number;
  isLast: boolean;
};

export const getAccordionRows = (filteredIssues: Issue[]) => {
  return filteredIssues?.map((issue) => ({
    title: issue.title,
    customContent: <IssueContent issue={issue} />,
  }));
};
